import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';
export function HomeNavigationLogo() {
  return <div className="flex items-center gap-4 flex-shrink-0" data-id="element-537">
      <Link to="/" className="flex items-center" data-id="element-538">
        <img src="https://cdn.magicpatterns.com/uploads/tu5GNqxjZDMpJfuNLHyDAD/NorthwestBlackBeltAcademy_logoCROPPEDTrans.png" alt="NWBBA Logo" className="h-20 w-auto" data-id="element-539" />
      </Link>

      {/* Address - Hidden on mobile and tablet */}
      <a href="https://www.google.com/maps/place/3815+196th+St+SW+%23109,+Lynnwood,+WA+98036" target="_blank" rel="noopener noreferrer" className="hidden xl:flex items-start gap-2 text-gray-600 hover:text-[#1e3a8a] transition-colors group" data-id="element-540">
        <MapPin className="w-5 h-5 text-[#1e3a8a] shrink-0 mt-0.5" data-id="element-541" />
        <div className="text-sm leading-tight" data-id="element-542">
          <div className="font-semibold" data-id="element-543">3815 196th St SW #109</div>
          <div data-id="element-544">Lynnwood, WA 98036</div>
        </div>
      </a>
    </div>;
}